import axios from "axios";
import getCurrentDatetime from "./getCurrentDatetime";
import generateCorrelationId from "./generateCorrelationId";
import constants from "../constants";

export default function axiosPost({
  url,
  data,
  headers,
  responseType,
  callback,
  errorCallback,
  uploadProgress,
}) {
  axios
    .post(url, data, {
      headers: {
        ...headers,
        "X-Transmission-Date-Time": getCurrentDatetime(),
        "X-Correlation-Id": generateCorrelationId(),
      },
      responseType: responseType,
      onUploadProgress: (progressEvent) => {
        if (uploadProgress) {
          const { loaded, total } = progressEvent;
          let percent = Math.floor((loaded * 100) / total);
          uploadProgress(percent);
        }
      },
    })
    .then((res) => {
      if (res.data.statusCode === constants.HTTP_STATUS_SUCCESS) {
        callback(res.data);
      } else {
        errorCallback(res.data);
      }
    })
    .catch((err) => {
      errorCallback(err);
    });
}
